// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
    flex-grow: 1;
  }
  
  .menu-icon {
    margin-right: 16px;
  }
  
  .navbar-title {
    flex-grow: 1;
  }
  
  .drawer-container {
    width: 240px;
    display: flex;
    flex-direction: column;
  }
  
  .drawer-logo img {
    width: 80%;
    max-width: 120px;
    margin: 16px auto;
  }
  
  .drawer-divider {
    margin-top: 8px;
  }
  
  .drawer-icon {
    margin-right: 16px;
  }
  
  .main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 100vh;
  }
  
  .main-logo {
    width: 50%;
    max-width: 400px;
    border-radius: 8px;
    margin-bottom: 40px;
  }
  
  .oriented-search-header {
    background-color: #3FA5D4;
    padding: 16px 0;
    border-radius: 8px 8px 0 0;
    text-align: center;
  }
  
  .oriented-search-body {
    background-color: #f2f2f2;
    border-radius: 8px;
    box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);
    padding: 24px;
    text-align: center;
    min-height: 400px;
  }
  
  .search-button {
    display: block; 
    width: 100%; 
    padding: 10px;
    font-size: 16px;
    cursor: not-allowed; 
    opacity: 0.5; 
    background-color: gray; 
    border: none;
    border-radius: 4px;
    color: white;
    transition: opacity 0.3s, background-color 0.3s, cursor 0.3s;
  }
  .search-button.enabled {
    cursor: pointer; /* Indicativo de estado clicável */
    opacity: 1; /* Totalmente visível */
    background-color: #3FA5D4; /* Cor para estado habilitado */
  }
  
  .search-button.disabled {
    cursor: not-allowed; /* Continua desativado */
    opacity: 0.5; /* Mantém transparência */
    background-color: gray; /* Fundo desativado */
  }
  
  .search-button.visible {
    visibility: visible; /* Sempre visível */
  }
  
  .no-data-message {
    margin-top: 32px;
  }
  
  .footer {
    background-color: #1c1c1c;
    color: white;
    padding: 32px 0;
    margin-top: 32px;
  }
  
  .footer-follow-us, .footer-contact {
    text-align: center;
  }
  
  .footer-icons {
    display: flex;
    justify-content: center;
    gap: 16px;
  }
  
  .footer-divider {
    margin: 24px 0;
    background-color: white;
  }
  .results-container {
    margin-top: 20px;
  }
  
  .results-list {
    list-style-type: none;
    padding: 0;
  }
  
  .result-link {
    color: #3FA5D4;
    text-decoration: none;
    font-size: 16px;
  }
  
 `, "",{"version":3,"sources":["webpack://./src/components/OrientedSearch/Orientedsearch.css"],"names":[],"mappings":"AAAA;IACI,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,4DAA4D;EAC9D;EACA;IACE,eAAe,EAAE,kCAAkC;IACnD,UAAU,EAAE,uBAAuB;IACnC,yBAAyB,EAAE,+BAA+B;EAC5D;;EAEA;IACE,mBAAmB,EAAE,wBAAwB;IAC7C,YAAY,EAAE,yBAAyB;IACvC,sBAAsB,EAAE,qBAAqB;EAC/C;;EAEA;IACE,mBAAmB,EAAE,mBAAmB;EAC1C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;EACjB","sourcesContent":[".main-container {\n    flex-grow: 1;\n  }\n  \n  .menu-icon {\n    margin-right: 16px;\n  }\n  \n  .navbar-title {\n    flex-grow: 1;\n  }\n  \n  .drawer-container {\n    width: 240px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .drawer-logo img {\n    width: 80%;\n    max-width: 120px;\n    margin: 16px auto;\n  }\n  \n  .drawer-divider {\n    margin-top: 8px;\n  }\n  \n  .drawer-icon {\n    margin-right: 16px;\n  }\n  \n  .main-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    min-height: 100vh;\n  }\n  \n  .main-logo {\n    width: 50%;\n    max-width: 400px;\n    border-radius: 8px;\n    margin-bottom: 40px;\n  }\n  \n  .oriented-search-header {\n    background-color: #3FA5D4;\n    padding: 16px 0;\n    border-radius: 8px 8px 0 0;\n    text-align: center;\n  }\n  \n  .oriented-search-body {\n    background-color: #f2f2f2;\n    border-radius: 8px;\n    box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);\n    padding: 24px;\n    text-align: center;\n    min-height: 400px;\n  }\n  \n  .search-button {\n    display: block; \n    width: 100%; \n    padding: 10px;\n    font-size: 16px;\n    cursor: not-allowed; \n    opacity: 0.5; \n    background-color: gray; \n    border: none;\n    border-radius: 4px;\n    color: white;\n    transition: opacity 0.3s, background-color 0.3s, cursor 0.3s;\n  }\n  .search-button.enabled {\n    cursor: pointer; /* Indicativo de estado clicável */\n    opacity: 1; /* Totalmente visível */\n    background-color: #3FA5D4; /* Cor para estado habilitado */\n  }\n  \n  .search-button.disabled {\n    cursor: not-allowed; /* Continua desativado */\n    opacity: 0.5; /* Mantém transparência */\n    background-color: gray; /* Fundo desativado */\n  }\n  \n  .search-button.visible {\n    visibility: visible; /* Sempre visível */\n  }\n  \n  .no-data-message {\n    margin-top: 32px;\n  }\n  \n  .footer {\n    background-color: #1c1c1c;\n    color: white;\n    padding: 32px 0;\n    margin-top: 32px;\n  }\n  \n  .footer-follow-us, .footer-contact {\n    text-align: center;\n  }\n  \n  .footer-icons {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n  }\n  \n  .footer-divider {\n    margin: 24px 0;\n    background-color: white;\n  }\n  .results-container {\n    margin-top: 20px;\n  }\n  \n  .results-list {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .result-link {\n    color: #3FA5D4;\n    text-decoration: none;\n    font-size: 16px;\n  }\n  \n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
